import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { MatMenuModule } from "@angular/material/menu";
import { CommonModule } from "@angular/common";
import { OverlayRef } from "@angular/cdk/overlay";
import { CardActionMenu } from "./card-action-menu.models";
import { boostThemeEnum } from "@app/services/page.service";
import { Overlay } from "@angular/cdk/overlay";
import { TemplatePortal } from "@angular/cdk/portal";
import { CardModel } from "src/swagger/api.client.generated";
import { CardMenuSignalService } from "@app/services/card-menu-signal.service";
import { FlipCoachTargetDirective } from "../../coach-mark/coach-mark-target.directive";
@Component({
  selector: "app-card-action-menu",
  templateUrl: "./card-action-menu.component.html",
  styleUrls: ["./card-action-menu.component.scss"],
  standalone: true,
  imports: [CommonModule, MatMenuModule, AngularSvgIconModule, FlipCoachTargetDirective],
})
export class CardActionMenuComponent {
  @Input() card: CardModel;
  @Input() iconThemeColor: boostThemeEnum = boostThemeEnum.forestpath;
  @Input() isEditable: boolean = false;
  /** When the editable card is a not-yet-created custom card, the edit item is shown as CREATE. */
  @Input() isCreate: boolean = false;
  @Input() showSwap: boolean = true;
  @Input() canDelete: boolean = true;
  @Input() canDuplicate: boolean = true;
  @Input() canRemove: boolean = false;
  /** Onboarding coach-mark anchor for the three-dot trigger (CA01 plan.card_menu, DM04 deck_manager.card_menu). */
  @Input() triggerAnchor: string | null = null;
  /**
   * Prefix of the per-row anchors inside the opened menu (CA02A-E: "plan.card_menu_" gives
   * plan.card_menu_remove, _favourite, _swap, _edit, _duplicate).
   */
  @Input() rowAnchorPrefix: string | null = null;

  @Output() actionClicked = new EventEmitter<CardActionMenu>();

  activeItem: CardActionMenu | null = null;

  /** The coach-mark anchor of one menu row, or null when this menu has none. */
  rowAnchor(row: "remove" | "favourite" | "swap" | "edit" | "duplicate"): string | null {
    return this.rowAnchorPrefix ? this.rowAnchorPrefix + row : null;
  }

  onActionClicked(action: CardActionMenu) {
    this.activeItem = action;
    this.cardMenuSignal.notifySelected(action);
    this.actionClicked.emit(action);
    this.closeMenu();
  }

  @ViewChild("menu") menuTemplate!: TemplateRef<any>;
  private overlayRef: OverlayRef | null = null;

  constructor(
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private el: ElementRef,
    private cardMenuSignal: CardMenuSignalService
  ) {}

  openMenu() {
    this.closeMenu();
    this.actionClicked.emit("open");
    this.cardMenuSignal.notifyOpened({ inPlan: this.canRemove });

    const cardFontSizePx = parseFloat(getComputedStyle(this.el.nativeElement).fontSize);
    const offsetY = Math.round(-1.75 * cardFontSizePx);

    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(this.el.nativeElement)
      .withPositions([
        {
          originX: "end",
          originY: "bottom",
          overlayX: "start",
          overlayY: "top",
        },
      ])
      .withDefaultOffsetX(0)
      .withDefaultOffsetY(offsetY);
    this.overlayRef = this.overlay.create({
      positionStrategy,
      hasBackdrop: true,
      backdropClass: "cdk-overlay-transparent-backdrop",
    });
    this.overlayRef.hostElement.style.fontSize = `${cardFontSizePx}px`;

    this.overlayRef.attach(
      new TemplatePortal(this.menuTemplate, this.viewContainerRef)
    );
    this.overlayRef.backdropClick().subscribe(() => this.closeMenu());
  }

  closeMenu() {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
      this.cardMenuSignal.notifyClosed();
    }
  }
}
